import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OurRoutes from './Routes';
import * as Routers from './Routers';
import AppLayout from './Adminlayout'
function AppRouter() {
  return (
    <Router>
      <Suspense fallback={<div></div>} >
        <Routes>

          <Route path={OurRoutes.LOGIN} element={<Routers.LOGIN />} />

          <Route element={<AppLayout />}>
            <Route path={OurRoutes.DASHBOARD} element={<Routers.DASHBOARD />} />
            <Route path={OurRoutes.ADMIN_USERS} element={<Routers.ADMIN_USERS />} />
            <Route path={OurRoutes.CLASSIC_USERS} element={<Routers.CLASSIC_USERS />} />
            <Route path={OurRoutes.CREATORS} element={<Routers.CREATORS />} />
            <Route path={OurRoutes.PRODUCTS} element={<Routers.PRODUCTS />} />
            {/* <Route path={OurRoutes.GIFTS} element={<Routers.GIFTS />} /> */}
            <Route path={OurRoutes.ITEMS} element={<Routers.ITEMS />} />
            <Route path={OurRoutes.SELFIES} element={<Routers.SELFIES />} />
            <Route path={OurRoutes.CART} element={<Routers.CART />} />
            <Route path={OurRoutes.BRANDS} element={<Routers.BRANDS />} />
            <Route path={OurRoutes.CATEGORIES} element={<Routers.CATEGORIES />} />
            <Route path={OurRoutes.SUBCATEGORIES} element={<Routers.SUBCATEGORIES />} />
            <Route path={OurRoutes.ROLES} element={<Routers.ROLES />} />
            <Route path={OurRoutes.CREDIT_CODES} element={<Routers.CREDIT_CODES />} />
            <Route path={OurRoutes.NOTIFICATION} element={<Routers.NOTIFICATION />} />

          </Route>

        </Routes>
      </Suspense>
    </Router>
  )
}
export default AppRouter